// Copied from advisor-3.0/src/components/Layout/SupportModal.js
// Changes: sessionStorage -> useAccount TanStack hook, TS types
import React from 'react';
import { Modal, Fade, IconButton, Typography, Box } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import { useAccount } from 'src/api/hooks/useAccount';
import GetFormattedNumber from 'src/components/Helpers/Formatters/GetFormattedNumber';
import './SupportModal.scss';

interface SupportModalProps {
  open: boolean;
  handleClose: () => void;
}

const SupportModal = ({ open, handleClose }: SupportModalProps) => {
  const { data } = useAccount();
  const accountDetails = data?.account;

  const contactDetailsList = [
    { name: 'Sales Team', email: accountDetails?.stEmail, contact: GetFormattedNumber(accountDetails?.stPhone) },
    { name: 'Application Team', email: accountDetails?.atEmail, contact: GetFormattedNumber(accountDetails?.atPhone) },
    { name: 'Case Management Team', email: accountDetails?.cmtEmail, contact: GetFormattedNumber(accountDetails?.cmtPhone) },
    { name: 'Covr Platform Support', email: accountDetails?.platformSupportEmail, contact: undefined },
  ];

  return (
    <Modal
      aria-labelledby="support-modal-title"
      className="d-flex align-items-center justify-content-center"
      open={open}
      onClose={handleClose}
      closeAfterTransition
      slotProps={{ backdrop: { timeout: 500 } }}
    >
      <Fade in={open}>
        <Box sx={(theme) => ({
          backgroundColor: theme.palette.background.paper,
          boxShadow: theme.shadows[5],
        })} className="modal-content">
          <IconButton
            aria-label="close"
            onClick={handleClose}
            sx={(theme) => ({
              color: '#ffffff',
              top: theme.spacing(1),
              right: theme.spacing(1),
            })}
            className="position-absolute"
          >
            <CloseIcon />
          </IconButton>
          <Box
            sx={(theme) => ({
              backgroundColor: theme.palette.primary.main,
              color: '#ffffff',
              p: theme.spacing(2),
              borderBottom: `1px solid ${theme.palette.divider}`,
              display: 'flex',
              alignItems: 'center',
            })}
          >
            <img alt="Covr Logo" src="/AdvisorImages/covr-logo-white.svg" />
            <Typography variant="h5" className="ml-5 font-weight-normal">Contact Covr</Typography>
          </Box>
          <Box
            sx={(theme) => ({
              p: theme.spacing(2),
              gap: theme.spacing(2),
              display: 'grid',
              gridTemplateColumns: '1fr 1fr 1.5fr',
            })}
          >
            <Typography />
            <Typography variant="body1" className="text-center"><b>Phone</b></Typography>
            <Typography variant="body1" className="text-center"><b>Email</b></Typography>
            {contactDetailsList.map((team, index) => (
              <React.Fragment key={index}>
                <Typography variant="body1" sx={(theme) => ({
                  fontWeight: 'bold',
                  color: theme.palette.primary.main,
                })}>{team.name}</Typography>
                <span className="text-center">
                  <a
                    style={{ textDecoration: 'none' }}
                    href={`tel:${team.contact}`}
                  >
                    {team.contact}
                  </a>
                </span>
                <span>
                  <a
                    style={{ textDecoration: 'none' }}
                    href={`mailto:${team.email}`}
                  >
                    {team.email}
                  </a>
                </span>
              </React.Fragment>
            ))}
          </Box>
        </Box>
      </Fade>
    </Modal>
  );
};

export default SupportModal;
